module.exports = __webpack_public_path__ + "img/A2.1184f6b7.png";